var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page home" }, [
    _c("main", { staticClass: "is-flex is-centered" }, [
      _c("div", { staticClass: "columns is-multiline" }, [
        _c("div", { staticClass: "column is-12-mobile is-4" }, [
          _c("div", { staticClass: "box" }, [
            _c(
              "h3",
              { staticClass: "indicator title is-4 title-calendar-debt" },
              [
                _c("div", [_vm._v("Total de deuda:")]),
                _c(
                  "div",
                  { staticClass: "has-text-weight-bold has-text-debt-total" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("toCurrency")(_vm.monthSummary.total, "MXN")
                      )
                    )
                  ]
                )
              ]
            )
          ])
        ]),
        _c("div", { staticClass: "column is-12-mobile is-4" }, [
          _c("div", { staticClass: "box" }, [
            _c(
              "h3",
              {
                staticClass: "indicator title is-4 title-calendar-debt-expired"
              },
              [
                _c("div", [_vm._v("Total Vencido:")]),
                _c(
                  "div",
                  { staticClass: "has-text-weight-bold has-text-debt-expired" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("toCurrency")(_vm.monthSummary.expired, "MXN")
                      )
                    )
                  ]
                )
              ]
            )
          ])
        ]),
        _c("div", { staticClass: "column is-12-mobile is-4" }, [
          _c("div", { staticClass: "box" }, [
            _c(
              "h3",
              {
                staticClass: "indicator title is-4 title-calendar-debt-overcome"
              },
              [
                _c("div", [_vm._v("Por Vencer:")]),
                _c(
                  "div",
                  { staticClass: "has-text-weight-bold has-text-debt" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("toCurrency")(
                          _vm.monthSummary.total - _vm.monthSummary.expired,
                          "MXN"
                        )
                      )
                    )
                  ]
                )
              ]
            )
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("app-calendar", {
            attrs: { events: _vm.debtsEvents, "event-limit": 2 },
            on: { "change:month": _vm.onChange },
            scopedSlots: _vm._u([
              {
                key: "event-card",
                fn: function(props) {
                  return [
                    _c(
                      "router-link",
                      {
                        staticClass: "debt is-flex",
                        attrs: {
                          to: {
                            name: "InvoiceDetail",
                            params: { uuid: props.event.id }
                          }
                        }
                      },
                      [
                        _c("span", { class: _vm.amountClass(props.event) }, [
                          _vm._v(
                            _vm._s(props.event.voucherSeries) +
                              "-" +
                              _vm._s(props.event.voucherConsecutive)
                          )
                        ]),
                        _c("span", { class: _vm.amountClass(props.event) }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("toCurrency")(
                                props.event.debt,
                                props.event.voucherCurrency
                              )
                            )
                          )
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }